/*
 * How much of the screen the bars take, as they really are: --top-offset (where the navbar ends, the announcement
 * included) and --bottom-offset (what the phone's tab bar covers; 0 on desktop, where it's hidden), on <html>.
 * Anything fixed to the screen uses them to stay clear of both: the phone's menus (x-drawer), the cookie banner,
 * toasts, dropdowns (keepOnScreen). Kept up to date as the window or any bar changes size, so the bars can be resized
 * freely; resources/css/base.css has the starting values.
 *
 * Sides too: --left-offset and --right-offset, the width a sidebar marked data-sidebar-left / data-sidebar-right takes
 * (0 while there's none, or it's hidden). There are no sidebars yet: this is ready for sidebar menus to come (owner,
 * 2026-10-22: for the future, leave it).
 */
const root = document.documentElement;
const resized = new ResizeObserver(measure);
// On the page and showing (a fixed one has no offsetParent, so that can't tell)
const shown = (element) => element?.checkVisibility?.() ?? !!element?.getClientRects().length;

function measure() {
    const navbar = document.querySelector('[data-navbar]');
    const tabbar = document.querySelector('[data-tabbar]');

    if (navbar) {
        root.style.setProperty('--top-offset', `${Math.round(navbar.offsetTop + navbar.offsetHeight)}px`);
    }

    // From the bottom of the window, which is what anything fixed to the bottom of the screen lines up with
    root.style.setProperty('--bottom-offset', shown(tabbar)
        ? `${Math.max(0, Math.round(window.innerHeight - tabbar.getBoundingClientRect().top))}px`
        : '0px');

    // Sidebars (none yet; see above): how far each reaches in from its side of the window
    const left = document.querySelector('[data-sidebar-left]');
    const right = document.querySelector('[data-sidebar-right]');

    root.style.setProperty('--left-offset', shown(left) ? `${Math.max(0, Math.round(left.getBoundingClientRect().right))}px` : '0px');
    root.style.setProperty('--right-offset', shown(right) ? `${Math.max(0, Math.round(window.innerWidth - right.getBoundingClientRect().left))}px` : '0px');
}

// The bars are new elements after each Livewire page change
function watch() {
    resized.disconnect();
    document.querySelectorAll('[data-announcement], [data-navbar], [data-tabbar], [data-sidebar-left], [data-sidebar-right]')
        .forEach((bar) => resized.observe(bar));
    measure();
}

window.addEventListener('resize', measure);
document.addEventListener('livewire:navigated', watch);
watch();
